import { useState, useEffect } from "react"
import { walletService } from "@/api/services"
import type { WalletResponseDto } from "@/api/types/wallet.types"
import { Card } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Loader2, Wallet } from "lucide-react"

interface WalletInfoProps {
  userId: string
}

export default function WalletInfo({ userId }: WalletInfoProps) {
  const [wallet, setWallet] = useState<WalletResponseDto | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadWallet = async () => {
      setLoading(true)
      try {
        const data = await walletService.getWalletByUserId(userId)
        setWallet(data)
      } catch {
        setWallet(null)
      } finally {
        setLoading(false)
      }
    }

    loadWallet()
  }, [userId])

  return (
    <Card className="p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Wallet className="h-5 w-5 text-foreground" />
        <h2 className="text-lg font-semibold text-foreground">Wallet</h2>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-4">
          <Loader2 className="w-5 h-5 animate-spin text-primary" />
        </div>
      ) : wallet ? (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-muted-foreground">Credit Balance</Label>
            <p className="text-foreground font-medium text-lg">{wallet.creditBalance}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Remaining Moto Quota</Label>
            <p className="text-foreground font-medium text-lg">{wallet.remainingMotoQuota}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Remaining Gear Quota</Label>
            <p className="text-foreground font-medium text-lg">{wallet.remainingGearQuota}</p>
          </div>
          <div>
            <Label className="text-muted-foreground">Contract Valid Until</Label>
            <p className="text-foreground font-medium">
              {wallet.activeQuotaValidTo
                ? new Date(wallet.activeQuotaValidTo).toLocaleDateString()
                : "N/A"}
            </p>
          </div>
        </div>
      ) : (
        <p className="text-muted-foreground">No wallet found.</p>
      )}
    </Card>
  )
}
